import { Component, OnInit, inject } from '@angular/core';
import {DataService} from "../../../services/data.service";
import {AccessService} from "../../../services/access.service";
import {PaginationComponent} from "ngx-bootstrap/pagination";
import {RouterLink} from "@angular/router";
import {DatePipe, NgForOf, NgIf} from "@angular/common";
import {YesNoPipe} from "../../../pipes/yes-no.pipe";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    imports: [
        PaginationComponent,
        RouterLink,
        NgIf,
        YesNoPipe,
        DatePipe,
        FormsModule,
        NgForOf
    ],
    styleUrl: './user-list.component.scss'
})
export class UserListComponent implements OnInit {

    accessService = inject(AccessService);
    private dataService = inject(DataService);

    paginConfig;
    entries;
    totalEntries;
    predicate;
    search;
    reverse;

    ngOnInit(): void {
        this.search = {
            text: ''
        };
        this.paginConfig = {
            itemsPerPage: 25,
            page: 1
        };
        this.reverse = false;
        this.totalEntries = 0;
        this.predicate = 'lastname';
        this.listEntries(this.paginConfig);
    }

    setOrder(order): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    checkFilterAndList(): void {
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    listEntries(event): void {
        this.paginConfig = event;

        this.entries = null;
        this.dataService.request('User/listAll', {
            page: this.paginConfig.page,
            limit: this.paginConfig.itemsPerPage,
            order: this.predicate,
            reverse: this.reverse,
            filter: this.search.text,
        }).subscribe(response => {
            this.totalEntries = response.total;
            this.entries = response.users;
            this.entries.forEach(entry => entry.active = entry.active === '1');
        });
    }

}
